export const caseUserRoles = {
	PLAINTIFF: "Plaintiff",
	DEFENDANT: "Defendant",
	COUNSEL: "Counsel",
};
